import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  templateUrl: "./consumidor-obrigado.component.html",
  styleUrls: ["./consumidor-obrigado.component.css"]
})
export class ConsumidorObrigadoComponent {
  script: HTMLScriptElement = document.createElement('script');

  constructor(private readonly route: Router) {
  }

  inserirAnalytics() {
    this.script.text = "gtag('event', 'conversion', {'send_to': 'AW-766717110/8fWQCJCxzZUBELbZzO0C'});";
    document.head.appendChild(this.script);
  };

  removerAnalytics() {
    document.head.removeChild(this.script);
  }

  redirecionar() {
    this.route.navigate(["/consumidor/"]);
  }


}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-obrigado/consumidor-obrigado.component.ts